import constructActionTypes from 'common/utils/constructActionTypes';

module.exports = constructActionTypes(
    {
        MOUNT_FORM_BUILDER: null,
        UNMOUNT_FORM_BUILDER: null,

        LOADING_BOOTSTRAP_DATA: null,
        LOADED_BOOTSTRAP_DATA: null,
        ERROR_LOADING_BOOTSTRAP_DATA: null,

        LOADING_FORM_DATA: null,
        LOADED_FORM_DATA: null,
        CLEAR_FORM_ENTITIES: null,
        SAVING_FORM_DATA: null,
        ERROR_SAVING_FORM_DATA: null,
        SAVED_FORM_DATA: null,

        BEGIN_DRAG_FORM_NODE: null,
        HOVER_DRAG_FORM_NODE: null,
        END_DRAG_FORM_NODE: null,

        OPEN_EDIT_FORM_NODE: null,
        SAVE_EDIT_FORM_NODE: null,
        SET_VALIDATION_ERRORS: null,
        REMOVE_VALIDATION_ERRORS: null,
        SET_LIVE_ERRORS: null,
        UPSERT_LIVE_ERRORS: null,
        OPEN_EDIT_FORM_NODE_LOGIC: null,
        CANCEL_EDIT_FORM_NODE_LOGIC: null,
        SAVE_EDIT_FORM_NODE_LOGIC: null,
        UPDATE_FORM: null,
        CREATE_FORM_NODES: null,
        OVERRIDE_FORM_NODE: null,
        DUPLICATE_FORM_NODE: null,
        UPDATE_FORM_NODE: null,
        UPDATE_FORM_NODE_CONFIG: null,
        ADD_FORM_NODE_OPTION: null,
        ADD_FORM_NODE_OPTIONS: null,
        REMOVE_FORM_NODE_OPTION: null,
        UPDATE_FORM_NODE_OPTION_RESPONSE_LIMIT: null,
        ADD_FORM_NODE_LOGIC: null,
        REMOVE_FORM_NODE_LOGIC: null,
        UPDATE_FORM_NODE_LOGIC: null,
        ADD_NODE_LOGIC_TO_FORM_NODE: null,
        REMOVE_NODE_LOGIC_FROM_FORM_NODE: null,
        SET_REQUIRED: null,
        ATTACH_FORM_NODE: null,
        REMOVE_FORM_NODE: null,
        CREATE_FORM_GROUP: null,
        CREATE_FORM_QUESTION: null,

        ADDING_QUESTION_TO_BANK: null,
        ADDED_QUESTION_TO_BANK: null,
        ERROR_ADDING_QUESTION_TO_BANK: null,

        OPENED_FORM_TEMPLATE_LIBRARY: null,
        CLOSED_FORM_TEMPLATE_LIBRARY: null,
        SET_FORM_TEMPLATE_LIBRARY_VIEW: null,

        SET_LOADING_FORM_TEMPLATE_LIBRARY: null,
        SET_LOADING_CUSTOM_TEMPLATES_NEXT_PAGE: null,
        ADD_CUSTOM_TEMPLATE: null,
        ADD_CUSTOM_TEMPLATES: null,
        SET_STOCK_TEMPLATES: null,
        RESET_FORM_TEMPLATES: null,
        SET_CUSTOM_TEMPLATES: null,
        REMOVE_QUESTION_FROM_CUSTOM_TEMPLATES: null,
        RESET_CUSTOM_TEMPLATES: null,
        SET_CUSTOM_TEMPLATES_SEARCH_TERM: null,
        SET_STOCK_TEMPLATES_SEARCH_TERM: null,
        SET_SELECTED_TEMPLATE_ID: null,

        SET_ACTIVE_SIDEBAR_TAB: null,

        OPEN_EDIT_FORM_HEADLINE_VIEW: null,
        CLOSE_SAVE_EDIT_FORM: null,

        OPEN_EDIT_FORM_SUBMIT_BUTTON: null,

        SET_FREEMIUM_SELECTED_MODAL: null,
        CLOSE_FREEMIUM_SELECTED_MODAL: null,

        OPEN_EDIT_FORM_TICKET_STYLING: null,

        SET_OPEN_STYLE_EDITOR_SECTION: null,
        SET_OPEN_TICKET_STYLE_EDITOR_SECTION: null,

        OVERRIDE_FORM_BUILDER_TICKET_STYLES: null,
        CLEAR_FORM_BUILDER_STATE: null,

        OPEN_ERROR_MESSAGE_MODAL: null,
        CLOSE_ERROR_MESSAGE_MODAL: null,

        SET_FORM_LIBRARY_NAME: null,
        SET_FORM_LIBRARY_STATUS: null,

        SET_FORM_LIBRARY_LIST: null,
        ADD_FORM_LIBRARY_LIST: null,

        SET_FORM_LIBRARY_PAGE: null,
        SET_PAGE_LIMIT_REACHED: null,

        SET_FORM_LIBRARY_SEARCH_TERM: null,
        SET_EVENT_THEME_COUNT: null,

        VALIDATE_FORM_DATA_FOR_SAVING: null,
        SET_FORM_LIBRARY_ERROR: null,
        SET_FORM_LIBRARY_FORM_ID: null,

        TOGGLE_IS_PRISTINE: null,
        SET_SCALED_FORM_MODAL_STATUS_OPEN: false,

        OPEN_SESSION_REGISTRATION_SETTING: false,
    },
    'formBuilder',
);
